<p>
    <a href="{{imageLocation}}{{mediaFileName}}" class="mediaLink" target="_blank">{{title}}</a>
    <span *ngIf="description !== ''">&nbsp;-&nbsp;{{description}}</span>
</p>
